import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiSharedModule } from '@icullen/api/shared';
import { ApiDocumentModule } from '@icullen/api/document';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { scopeLoader, UtilsModule } from '@icullen/utils';
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { MainNavigationComponent } from './main-navigation/main-navigation.component';
import { MobileTableComponent } from './document-viewer/mobile-table/mobile-table.component';
import { RelatedDocComponent } from './document-viewer/related-posts/related-doc/related-doc.component';
import { OtherVersionMobileComponent } from './document-viewer/other-version/other-version-mobile.component';
import { OtherVersionDesktopComponent } from './document-viewer/other-version/other-version-desktop.component';
import { OtherVersionComponent } from './document-viewer/other-version/other-version.component';
import { RouterModule } from '@angular/router';
import { DocumentMobileComponent } from './document-viewer/document/document-mobile.component';
import { DocumentDesktopComponent } from './document-viewer/document/document-desktop.component';
import { DocumentComponent } from './document-viewer/document/document.component';
import { RelatedDocsComponent } from './document-viewer/related-posts/related-docs/related-docs.component';
import { SimilarDocsComponent } from './document-viewer/related-posts/similar-docs/similar-docs.component';
import { ActionIconsComponent } from './document-viewer/action-icons/action-icons.component';
import { DemoContentComponent } from './document-viewer/demo/demo-content/demo-content.component';
import { SectionComponent } from './document-viewer/section/section.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { PaywallComponent } from './document-viewer/demo/paywall/paywall.component';
import { LoginComponent } from './document-viewer/demo/login/login.component';
import { SubscribeComponent } from './document-viewer/demo/subscribe/subscribe.component';
import { DocumentMiniInfoComponent } from './document-viewer/demo/document-mini-info/document-mini-info.component';
import { SubscriptionInfoComponent } from './document-viewer/demo/subscription-info/subscription-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpgradeSubscriptionComponent } from './document-viewer/upgrade-subscription/upgrade-subscription.component';
import { ForgotPasswordComponent } from './document-viewer/demo/forgot-password/forgot-password.component';
import { CompetitionLawComponent } from './document-viewer/competition-law/competition-law.component';
import { PillarTocComponent } from './document-viewer/toc/pillar-toc/pillar-toc.component';
import { PillarTocContainerComponent } from './document-viewer/toc/containers/pillar-toc-container/pillar-toc-container.component';
import { TocContainerComponent } from './document-viewer/toc/containers/toc-container/toc-container.component';
import { GroupMatrixContainerComponent } from './document-viewer/toc/containers/group-matrix-container/group-matrix-container.component';
import { GroupMatrixComponent } from './document-viewer/toc/group-matrix/group-matrix.component';
import { GroupListContainerComponent } from './document-viewer/toc/containers/group-list-container/group-list-container.component';
import { GroupListComponent } from './document-viewer/toc/group-list/group-list.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { FavoriteComponent } from './favorite/favorite.component';
import { AccountWarningComponent } from './account-warning/account-warning.component';
import { CountryUpdateComponent } from './document-viewer/country-update/country-update.component';
import { CountryUpdateDesktopComponent } from './document-viewer/country-update/country-update-desktop.component';
import { CountryUpdateMobileComponent } from './document-viewer/country-update/country-update-mobile.component';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { TagsComponent } from './document-viewer/competition-law/tags/tags.component';
import { SectionBasedTocComponent } from './document-viewer/section-based-toc/section-based-toc.component';
import { TopicsComponent } from './document-viewer/topics/topics.component';

@NgModule({
  imports: [
    CommonModule,
    ApiSharedModule,
    ApiDocumentModule,
    RouterModule,
    TranslocoModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    NgxPageScrollModule,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'uishared',
        loader: scopeLoader((lang) => import(`./i18n/${lang}.json`)),
      },
    },
    DeviceDetectorService,
  ],
  declarations: [
    DocumentViewerComponent,
    MainNavigationComponent,
    MobileTableComponent,
    RelatedDocComponent,
    OtherVersionMobileComponent,
    OtherVersionDesktopComponent,
    OtherVersionComponent,
    DocumentMobileComponent,
    DocumentDesktopComponent,
    DocumentComponent,
    RelatedDocsComponent,
    SimilarDocsComponent,
    ActionIconsComponent,
    DemoContentComponent,
    SectionComponent,
    SubscribeComponent,
    LoginComponent,
    PaywallComponent,
    DocumentMiniInfoComponent,
    UpgradeSubscriptionComponent,
    SubscriptionInfoComponent,
    ForgotPasswordComponent,
    CompetitionLawComponent,
    PillarTocComponent,
    PillarTocContainerComponent,
    TocContainerComponent,
    GroupMatrixContainerComponent,
    GroupMatrixComponent,
    GroupListContainerComponent,
    GroupListComponent,
    SearchBarComponent,
    FavoriteComponent,
    AccountWarningComponent,
    CountryUpdateComponent,
    CountryUpdateDesktopComponent,
    CountryUpdateMobileComponent,
    TagsComponent,
    SectionBasedTocComponent,
    TopicsComponent,
  ],
  exports: [
    DocumentViewerComponent,
    DocumentDesktopComponent,
    MainNavigationComponent,
    SearchBarComponent,
    FavoriteComponent,
    SectionComponent,
    PaywallComponent,
    AccountWarningComponent,
    TopicsComponent,
  ],
})
export class FeatureSharedModule {}
